<template>
  <div>
    <AllCases :selectedStatuses="statuses"></AllCases>
  </div>
</template>

<script>
const AllCases = defineAsyncComponent(() =>
  import("@/components/cases/AllCases")
);
import { defineAsyncComponent } from "vue";
import UserPermissionsHelper from "@/mixins/UserPermissionsHelper";
export default {
  components: {
    AllCases,
  },
  mixins:[UserPermissionsHelper],
  data() {
    return {
      statuses: ["ACTIVE"],
    };
  },
  computed:{
    selectedStatus(){
      if(this.hasPermission('orders', 'create_new')){
        return ["ACTIVE","TEST_REPORTS"]
      } else{
        return ["ACTIVE"]
      }
    }
  }
};
</script>
